import React from "react";

import "./Header.scss";

function Header() {
  return (
    <div className="Header">
      <h1>🥐 Grocery shopping list</h1>
    </div>
  );
}

export default Header;
